import { render } from "./WareHouseRegionListPage.vue?vue&type=template&id=a381e500&scoped=true"
import script from "./WareHouseRegionListPage.vue?vue&type=script&lang=js"
export * from "./WareHouseRegionListPage.vue?vue&type=script&lang=js"

import "./WareHouseRegionListPage.vue?vue&type=style&index=0&id=a381e500&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a381e500"

export default script